export const MultiValuedListVariant = {
  Tag: 'tag',
}

export const MultiValuedListSize = {
  ExtraLarge: 'x-large',
  Large: 'large',
  Medium: 'medium',
  Small: 'small',
}
